import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { verifyEmail } from "../services/api";
import styles from "../css/shared.module.css";

const VerifyEmailPage = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("loading");
  const token = searchParams.get("token");

  useEffect(() => {
    const verify = async () => {
      if (!token) {
        setStatus("noToken");
        return;
      }

      // Add a short delay to ensure the DB is updated before verifying
      await new Promise((resolve) => setTimeout(resolve, 1000));

      const result = await verifyEmail(token);
      setStatus(result.success ? "success" : "error");
    };

    verify();
  }, [token]);

  return (
    <div className={styles.authContainer}>
      <div className={styles.formBox}>
        {status === "loading" && <p>🔄 Verifying your email...</p>}
        {status === "success" && (
          <p style={{ color: "green", fontWeight: "bold" }}>
            ✅ Email verified successfully! You can now login.
          </p>
        )}
        {status === "error" && (
          <p style={{ color: "red", fontWeight: "bold" }}>
            ❌ Invalid or expired verification link.
          </p>
        )}
        {status === "noToken" && (
          <p style={{ color: "red", fontWeight: "bold" }}>
            ❌ No verification token provided.
          </p>
        )}
      </div>
    </div>
  );
};

export default VerifyEmailPage;
